import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=3de9e5ef"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=3de9e5ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports